var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 144,
    viewBox: "0 0 232 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 144,
    fill: "url(#paint0_linear_274_1515)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 40C97.75 40 96 41.875 96 44C96 46.25 97.75 48 100 48H106.25L81.125 73.25C79.5 74.75 79.5 77.375 81.125 78.875C82.625 80.5 85.25 80.5 86.75 78.875L112 53.75V60C112 62.25 113.75 64 116 64C118.125 64 120 62.25 120 60V44C120 41.875 118.125 40 116 40H100ZM152 50C152 47.875 150.75 46 149 44.875C147.125 43.75 144.75 43.75 143 44.875C141.125 46 140 47.875 140 50C140 52.25 141.125 54.125 143 55.25C144.75 56.375 147.125 56.375 149 55.25C150.75 54.125 152 52.25 152 50ZM136 66C136 63.875 134.75 62 133 60.875C131.125 59.75 128.75 59.75 127 60.875C125.125 62 124 63.875 124 66C124 68.25 125.125 70.125 127 71.25C128.75 72.375 131.125 72.375 133 71.25C134.75 70.125 136 68.25 136 66ZM130 88C132.125 88 134 86.875 135.125 85C136.25 83.25 136.25 80.875 135.125 79C134 77.25 132.125 76 130 76C127.75 76 125.875 77.25 124.75 79C123.625 80.875 123.625 83.25 124.75 85C125.875 86.875 127.75 88 130 88ZM136 98C136 95.875 134.75 94 133 92.875C131.125 91.75 128.75 91.75 127 92.875C125.125 94 124 95.875 124 98C124 100.25 125.125 102.125 127 103.25C128.75 104.375 131.125 104.375 133 103.25C134.75 102.125 136 100.25 136 98ZM152 98C152 95.875 150.75 94 149 92.875C147.125 91.75 144.75 91.75 143 92.875C141.125 94 140 95.875 140 98C140 100.25 141.125 102.125 143 103.25C144.75 104.375 147.125 104.375 149 103.25C150.75 102.125 152 100.25 152 98ZM114 88C116.125 88 118 86.875 119.125 85C120.25 83.25 120.25 80.875 119.125 79C118 77.25 116.125 76 114 76C111.75 76 109.875 77.25 108.75 79C107.625 80.875 107.625 83.25 108.75 85C109.875 86.875 111.75 88 114 88ZM120 98C120 95.875 118.75 94 117 92.875C115.125 91.75 112.75 91.75 111 92.875C109.125 94 108 95.875 108 98C108 100.25 109.125 102.125 111 103.25C112.75 104.375 115.125 104.375 117 103.25C118.75 102.125 120 100.25 120 98ZM98 104C100.125 104 102 102.875 103.125 101C104.25 99.25 104.25 96.875 103.125 95C102 93.25 100.125 92 98 92C95.75 92 93.875 93.25 92.75 95C91.625 96.875 91.625 99.25 92.75 101C93.875 102.875 95.75 104 98 104ZM152 82C152 79.875 150.75 78 149 76.875C147.125 75.75 144.75 75.75 143 76.875C141.125 78 140 79.875 140 82C140 84.25 141.125 86.125 143 87.25C144.75 88.375 147.125 88.375 149 87.25C150.75 86.125 152 84.25 152 82ZM146 72C148.125 72 150 70.875 151.125 69C152.25 67.25 152.25 64.875 151.125 63C150 61.25 148.125 60 146 60C143.75 60 141.875 61.25 140.75 63C139.625 64.875 139.625 67.25 140.75 69C141.875 70.875 143.75 72 146 72Z",
    fill: "url(#paint1_linear_274_1515)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_274_1515",
    x1: 116,
    y1: 0,
    x2: 116,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_274_1515",
    x1: 116,
    y1: 40,
    x2: 116.247,
    y2: 162.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#6D5EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4B1E8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperational);
export default __webpack_public_path__ + "static/media/Operational.d225baa6ad13ed7f360f21acf28da5ea.svg";
export { ForwardRef as ReactComponent };